module.exports = __webpack_public_path__ + "img/recommed-img6.ae2d4eaa.jpg";